import { render, staticRenderFns } from "./EmployeeTabFiles.vue?vue&type=template&id=a2f35152&scoped=true&"
import script from "./EmployeeTabFiles.vue?vue&type=script&lang=js&"
export * from "./EmployeeTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f35152",
  null
  
)

export default component.exports